module.exports = __webpack_public_path__ + "img/skateboard.39616c77.gif";